export const usersFaq = [
  {
    id: "users0",
    title: "What kind of classes are offered through the Teache app?",
    text: "Teache offers an incredible array of in-person classes – you can learn everything from surfing to rock-climbing to playing the guitar. The types of classes you can take are only limited by the teachers available in your area.",
  },
  {
    id: "users1",
    title: "How do you book a class?",
    text: "The Teache app lets you scroll through available classes and instructors. Once you find one you’re interested in, you can use the app to book a date and time that works for you. ",
  },
  {
    id: "users2",
    title: "Are Teache classes online or in-person?",
    text: "Right now, our focus is solely on in-person classes. ",
  },
  {
    id: "users3",
    title: "Where do Teache classes take place?",
    text: "Class locations will depend on your instructor(s). Some instructors prefer to do their classes at their homes or at a local park, while others may hold classes at their place of business. ",
  },
  {
    id: "users4",
    title: "How are payments processed?",
    text: "Payments will be processed through the Teache app after the class takes place.",
  },
  {
    id: "users5",
    title: "What kind of teachers can I find on the Teache app?",
    text: "Teachers of all kinds, - from veteran, licensed professionals to subject experts sharing their knowledge for the first time, – use the Teache app.",
  },
  {
    id: "users6",
    title: "How can I communicate with a teacher?",
    text: "The Teache app has a chat feature that allows you to communicate with teachers you are interested in hiring.",
  },
  {
    id: "users7",
    title: "What is the cancellation policy for a Teache class?",
    text: "Each teacher has their own cancellation policy, with varying levels of flexibility being offered. Before booking your class, you’ll be able to see your specific teacher’s cancellation policy.",
  },
  {
    id: "users8",
    title: "What happens if I have to cancel a class?",
    text: "If you must cancel your class, please reach out to your instructor and let them know. Refunds are dependent on your specific teacher’s cancellation policy.",
  },
  {
    id: "users9",
    title: "How much does a class cost?",
    text: "The cost of a class is determined by its instructor. ",
  },
  {
    id: "users10",
    title: "How long is a typical class?",
    text: "A class’s duration is determined by its instructor.",
  },
  {
    id: "users11",
    title: "Do I need to prepare anything before I can take a class?",
    text: "Instructors will indicate what (if anything) is required to take their class in their profile. Some class requirements are minor (e.g., “bring sneakers”), while some classes can require more serious or expensive equipment (e.g., a surfboard). If you have questions, it’s best to review requirements with your instructor prior to booking their class.",
  },
  {
    id: "users12",
    title: "How do I dispute a class payment?",
    text: "You can request a refund from an instructor through the Teache app. In the event that you and your instructor are in disagreement, a Teache representative will review the case and relevant information and will then make a decision to resolve the dispute.",
  },
  {
    id: "users13",
    title: "How do I report an issue with a class?",
    text: "You can report an issue with a class through the Teache app by going to ‘Settings’.From there, you can reach a customer service team member, who will help you resolve your problem.",
  },
  {
    id: "users14",
    title:
      "Do I need to be of a certain skill level before I can take a class?",
    text: "It depends entirely on your instructor. Some instructors may only teach beginners, while others may focus solely on teaching experienced students. You will be able to see what skill level(s) an instructor caters to on their Teache profile.",
  },
  {
    id: "users15",
    title: "Can I leave a review for my teacher after the class?",
    text: "Yes, you are encouraged to leave a review after a class! Reviews of instructors will help future students as well as the instructors themselves",
  },
  {
    id: "users16",
    title: "Are classes done privately or in groups?",
    text: "The type of class depends on the instructor. Some instructors do only private lessons, some do only group lessons, and others can accommodate either.",
  },
  {
    id: "users17",
    title: "Can I see how many people there will be in a group class?",
    text: "Yes. Different instructors may have different group class capacities. Every class’s capacity is listed in its instructors’ profile on the Teache app, so you’ll be able to get an idea of how many fellow classmates you’ll have before booking.",
  },
];
export const instructorsFaq = [
  {
    id: "instructors0",
    title: "How can I sign up to become an instructor on the Teache app?",
    text: "Download the app and fill out the sign-up form to become a Teache instructor. Then, select the type of class you want to teach, and set your availability – it’s that easy!",
  },
  {
    id: "instructors1",
    title:
      "What happens if the type of class I want to teach is not in the app?",
    text: "We are constantly expanding the types of classes offered through the Teache app.If the type of class you want to teach is not in the app yet, please describe it(when prompted) during the instructor sign- up.We will review and let you know if we are able to include it.",
  },
  {
    id: "instructors2",
    title: "How do I get paid for my classes?",
    text: "After a class is over, we will release your students’ payments directly to you. The payment can be deposited directly into your bank account.",
  },
  {
    id: "instructors3",
    title: "How can I set up available hours?",
    text: "When signing up as an instructor, you will be able to select the dates and times you are available to give classes. You can always change your availability in the app in the ‘Settings’ section. ",
  },
  {
    id: "instructors4",
    title: "How do students book classes?",
    text: "The student will send you (the instructor) a request to book a class. You will then be able to review and accept the booking request; – only after you accept the request will the class be confirmed.",
  },
  {
    id: "instructors5",
    title: "Can I communicate with the students before they book a class?",
    text: "Yes, you can message prospective students before they book a class.",
  },
  {
    id: "instructors6",
    title: "Can I provide discounts?",
    text: "Yes, the Teache app allows you to provide customers with several types of discounts, including a “first class” discount and discounts based on the number of classes being booked.",
  },
  {
    id: "instructors7",
    title: "What information can I share on my profile?",
    text: "On your profile, you will be able to share detailed and relevant information about you and your class. Additionally, you will be able to post photos of your class to show prospective students what to expect.",
  },
  {
    id: "instructors8",
    title: "How do I cancel a class?",
    text: "If you must cancel a class, you can do that in the app under the ‘Upcoming Classes’ page.You will have to provide a cancellation explanation for your student(s) prior to canceling the class.",
  },
  {
    id: "instructors9",
    title: "Can I track my booking income on the Teache app?",
    text: "Yes, you will be able to track the income you have received from your classes booked through Teache. Income can be charted and displayed on a weekly, monthly, or yearly basis, helping you keep track of your earnings over time.",
  },
  {
    id: "instructors10",
    title: "What is Teache's fee?",
    text: "Teache's fee is 20% of the class booking cost charged to the instructor. For example, if a class costs $100, the user will pay $100, the instructor will receive $80, and Teache's fee would be $20.",
  },
];
